import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Trigger from "./Trigger";
import Overlay from "./Overlay";
import OverlayPortal from "../OverlayPortal";
import { overlayDirections } from "../../styles/mixins/overlays";
var propTypes = {
  /** Where the overlay will appear in relation to its target */
  placement: PropTypes.oneOf(['top', 'topRight', 'topLeft', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),

  /** Can accept any JSX, meant for the actual overlay (such as a Tooltip or Popover) */
  overlay: PropTypes.node,

  /** Can accept an JSX, meant for a button or icon that triggers the overlay */
  children: PropTypes.node,

  /** Determines whether a React Portal is rendered around the overlay */
  withPortal: PropTypes.bool,

  /** Function that hides overlay. */
  closeOverlay: PropTypes.func
};
var OverlayTrigger = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      overlay = _ref.overlay,
      placement = _ref.placement,
      withPortal = _ref.withPortal,
      closeOverlay = _ref.closeOverlay,
      props = _objectWithoutProperties(_ref, ["children", "overlay", "placement", "withPortal", "closeOverlay"]);

  return React.createElement(Trigger, Object.assign({}, props, {
    ref: ref
  }), children, overlay && (withPortal && ref && ref.current ? React.createElement(OverlayPortal, {
    overlayPosition: ref.current.getBoundingClientRect(),
    closeOverlay: closeOverlay
  }, React.createElement(Overlay, {
    placement: placement
  }, overlay)) : React.createElement(Overlay, {
    placement: placement
  }, overlay)));
});
OverlayTrigger.propTypes = propTypes; // export placement options

Object.keys(overlayDirections).forEach(function (placement) {
  OverlayTrigger[placement] = placement;
});
export default OverlayTrigger;